import { render } from "./S124810.vue?vue&type=template&id=c2054dba"
const script = {}
script.render = render

export default script